<template>
    <div class="q-gutter-y-md">
        <q-table
            class="sticky-container-table"
            title="Trial Phase Calendars"
            :rows="rows"
            :columns="columns"
            :loading="loading"
            row-key="id"
            flat
            bordered
            :pagination="pagination"
        >
            <template v-slot:body-cell-name="props">
                <q-td :props="props">
                    <a
                        :href="'/dev/calendar/' + props.row.id"
                        class="text-primary text-weight-bold"
                    >
                        {{ props.row.name }}
                    </a>
                </q-td>
            </template>

            <template v-slot:body-cell-coordinators="props">
                <q-td :props="props">
                    <div
                        v-for="coord in props.row.coordinators"
                        :key="coord.id"
                        class="q-mb-xs"
                    >
                        <a
                            :href="'/dev/publisher/' + coord.id"
                            class="text-secondary"
                        >
                            {{ coord.name }}
                        </a>
                        <q-badge color="grey-7" class="q-ml-xs">
                            {{ coord.count }}
                        </q-badge>
                    </div>
                </q-td>
            </template>

            <template v-slot:body-cell-remainingDays="props">
                <q-td :props="props">
                    <q-badge
                        :color="
                            props.row.remainingDays <= 5
                                ? 'negative'
                                : props.row.remainingDays <= 14
                                  ? 'warning'
                                  : 'positive'
                        "
                    >
                        {{ props.row.remainingDays }} days
                    </q-badge>
                </q-td>
            </template>

            <template v-slot:body-cell-lastActivity="props">
                <q-td :props="props">
                    <div v-if="props.row.lastActivity">
                        {{ props.row.lastActivity }}
                        <div class="text-grey text-caption">
                            {{ props.row.lastActivityHuman }}
                        </div>
                    </div>
                    <span v-else class="text-grey">Never</span>
                </q-td>
            </template>

            <template v-slot:body-cell-plan="props">
                <q-td :props="props">
                    <q-badge
                        :color="
                            props.row.plan === 'free'
                                ? 'grey'
                                : props.row.plan.includes('Decision')
                                  ? 'orange'
                                  : 'primary'
                        "
                    >
                        {{ props.row.plan }}
                    </q-badge>
                </q-td>
            </template>

            <template v-slot:body-cell-actions="props">
                <q-td :props="props" class="text-right">
                    <q-btn
                        flat
                        dense
                        color="primary"
                        icon="visibility"
                        :href="'/dev/calendar/' + props.row.id"
                    >
                        <q-tooltip>Show Details</q-tooltip>
                    </q-btn>
                </q-td>
            </template>
        </q-table>
    </div>
</template>

<script>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useQuasar } from "quasar";

export default {
    setup() {
        const $q = useQuasar();
        const rows = ref([]);
        const loading = ref(false);
        const pagination = ref({
            sortBy: "remainingDays",
            descending: false,
            page: 1,
            rowsPerPage: 50,
        });

        const columns = [
            {
                name: "id",
                label: "ID",
                field: "id",
                sortable: true,
                align: "left",
            },
            {
                name: "name",
                label: "Calendar Name",
                field: "name",
                sortable: true,
                align: "left",
            },
            {
                name: "publisherCount",
                label: "Publishers",
                field: "publisherCount",
                sortable: true,
                align: "center",
            },
            {
                name: "coordinators",
                label: "Coordinators",
                field: "coordinators",
                align: "left",
            },
            {
                name: "trialEndDate",
                label: "Trial End",
                field: "trialEndDate",
                sortable: true,
                align: "left",
            },
            {
                name: "remainingDays",
                label: "Days Left",
                field: "remainingDays",
                sortable: true,
                align: "center",
            },
            {
                name: "lastActivity",
                label: "Last Activity",
                field: "lastActivity",
                sortable: true,
                align: "left",
            },
            {
                name: "plan",
                label: "Payment Group Status",
                field: "plan",
                sortable: true,
                align: "left",
            },
            {
                name: "actions",
                label: "Actions",
                field: "actions",
                align: "right",
            },
        ];

        const fetchTrialCalendars = () => {
            loading.value = true;
            axios
                .get("/dev/api/subscriptions/trial")
                .then((response) => {
                    rows.value = response.data.rows;
                    loading.value = false;
                })
                .catch((error) => {
                    loading.value = false;
                    $q.notify({
                        color: "negative",
                        message: "Failed to fetch trial calendars",
                        icon: "report_problem",
                    });
                });
        };

        onMounted(() => {
            fetchTrialCalendars();
        });

        return {
            rows,
            columns,
            loading,
            pagination,
        };
    },
};
</script>
